var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.064,
    height: 27.371,
    viewBox: "770.621 521.865 30.064 27.371",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M771.615 523.877a1.016 1.016 0 0 1-.994-1.018 1.01 1.01 0 0 1 .994-.994h1.468a4.679 4.679 0 0 1 2.432.637c1.331.844 1.569 2.05 1.909 3.41h22.268a.996.996 0 0 1 .993.994 1.224 1.224 0 0 1-.051.306l-2.591 10.464a.979.979 0 0 1-.98.766H780.78c.357 1.323.714 2.036 1.196 2.366.588.389 1.615.409 3.311.389h11.533a.993.993 0 1 1 0 1.987h-11.516c-2.111.024-3.41-.027-4.453-.712-1.043-.685-1.63-1.936-2.19-4.16l-3.404-12.908c0-.025 0-.025-.027-.052a1.777 1.777 0 0 0-.764-1.145 2.606 2.606 0 0 0-1.397-.33h-1.453Zm19.654 6.117a.707.707 0 0 1 1.385 0v3.845a.707.707 0 0 1-1.385 0v-3.84Zm-4.148 0a.707.707 0 0 1 1.388 0v3.845a.707.707 0 0 1-1.388 0v-3.84Zm-4.145 0a.707.707 0 0 1 1.385 0v3.845a.707.707 0 0 1-1.385 0v-3.84Zm10.21-2.1h-15.207l2.266 8.531h16.07l2.114-8.53h-5.244Zm.655 16.447a2.447 2.447 0 1 1 0 4.895 2.447 2.447 0 0 1 0-4.895Zm-10.718 0a2.447 2.447 0 1 1 0 4.895 2.447 2.447 0 0 1 0-4.895Z",
    fill: "#82ceee",
    fillRule: "evenodd",
    "data-name": "cart-icon (1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesIcon);
export default __webpack_public_path__ + "static/media/SalesIcon.543c3b01a1d70e6d97eb6944d110c249.svg";
export { ForwardRef as ReactComponent };